import { render, staticRenderFns } from "./GalleryManager.vue?vue&type=template&id=675a8dda&scoped=true&"
import script from "./GalleryManager.vue?vue&type=script&lang=js&"
export * from "./GalleryManager.vue?vue&type=script&lang=js&"
import style0 from "./GalleryManager.vue?vue&type=style&index=0&id=675a8dda&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "675a8dda",
  null
  
)

export default component.exports